import { useI18n } from "@/i18n/I18nContext";
import { LegalProse } from "@/pages/components/LegalProse";
import { TextPageLayout } from "@/pages/components/TextPageLayout";
import { DocumentHead } from "@/seo/DocumentHead";
import { PAGE_SEO } from "@/seo/pageMeta";

const h2 = "mb-4 text-3xl text-[#111111]";

export function TermsOfServicePage() {
  const { messages } = useI18n();
  const t = messages.legal.terms;
  const seo = PAGE_SEO["/terms-of-service"];

  return (
    <TextPageLayout title={t.pageTitle} lastUpdatedLine={t.lastUpdated}>
      <DocumentHead
        title={`${t.pageTitle} — WasOK`}
        description={seo.description}
        path="/terms-of-service"
      />
      <section>
        <h2 className={h2}>{t.acceptance.title}</h2>
        <LegalProse text={t.acceptance.body} />
      </section>

      <section>
        <h2 className={h2}>{t.license.title}</h2>
        <LegalProse text={t.license.body} />
      </section>

      <section>
        <h2 className={h2}>{t.acceptableUse.title}</h2>
        <LegalProse text={t.acceptableUse.body} />
      </section>

      <section>
        <h2 className={h2}>{t.localData.title}</h2>
        <LegalProse text={t.localData.body} />
      </section>

      <section>
        <h2 className={h2}>{t.advertisements.title}</h2>
        <LegalProse text={t.advertisements.body} />
      </section>

      <section>
        <h2 className={h2}>{t.noWarranty.title}</h2>
        <LegalProse text={t.noWarranty.body} />
      </section>

      <section>
        <h2 className={h2}>{t.limitationLiability.title}</h2>
        <LegalProse text={t.limitationLiability.body} />
      </section>

      <section>
        <h2 className={h2}>{t.thirdParty.title}</h2>
        <LegalProse text={t.thirdParty.body} />
      </section>

      <section>
        <h2 className={h2}>{t.productInformation.title}</h2>
        <LegalProse text={t.productInformation.body} />
      </section>

      <section>
        <h2 className={h2}>{t.changesApp.title}</h2>
        <LegalProse text={t.changesApp.body} />
      </section>

      <section>
        <h2 className={h2}>{t.changesTerms.title}</h2>
        <LegalProse text={t.changesTerms.body} />
      </section>

      <section>
        <h2 className={h2}>{t.contact.title}</h2>
        <LegalProse text={t.contact.body} />
      </section>
    </TextPageLayout>
  );
}
